import { addNotificationToStore } from "./notification.store";
import type { NotificationOptions, NotificationType } from "./types";
import { NOTIFICATION_TYPES } from "./types";

type Notifier = (message: string, options?: NotificationOptions) => void;

function createNotifier(type: NotificationType): Notifier {
    return (message, options) => {
        addNotificationToStore({
            type,
            message,
            ...options,
        });
    };
}

const notifiers: Record<NotificationType, Notifier> = {
    success: createNotifier("success"),
    error: createNotifier("error"),
    info: createNotifier("info"),
    warning: createNotifier("warning"),
};

for (const type of NOTIFICATION_TYPES) {
    notifiers[type] ??= createNotifier(type);
}

/**
 * Императивный API уведомлений приложения.
 * Требует смонтированного {@link NotificationProvider}.
 */
export const notification = notifiers;

export type NotificationAPI = typeof notification;

export default notification;
